const objFunc = () => {
  return {
    appointmentId: undefined,
    appointmentDate: undefined,
    customerId: undefined,
    storeNumber: undefined,
    timezone: undefined
  }
}

export default objFunc()

export const defaultObj = objFunc()
